<script>
</script>

<div class="container" id="about">
    <h1>Simonsson & Widerberg Lean Consulting AS</h1>
    <h4>
        Simonsson & Widerberg was founded 2012 in Storvik, Gildeskål, Norway and
        in Varekil, Orust, Sweden. We offer companies support to go from
        traditional production or services to a Lean System that is robust and
        visual and that will secure continuous improvement.
    </h4>
    <hr />
    <div class="grid">
        <div>
            <h2>We offer</h2>
            <p>
                Simonsson & Widerberg supports companies to create as well as
                implement effective processes. This is done by reducing waste
                and improve the value stream. With a Lean System and Lean
                Leadership the company will free up resources that can be
                reinvested for later growth.
            </p>
        </div>
        <div class="">
            <h2>Our experience</h2>
            <p>
                We have international experience from working in many countries
                and different cultures: Belgium, Canada, Czech Republic,
                Denmark, France, Germany, Great Britain, Italy, Japan,
                Netherlands, Norway, Poland, Romania, Serbia, Slovakia, Spain,
                Sweden, US.
            </p>
        </div>
        <div class="">
            <h2>Vision</h2>
            <p>
                Our vision is that good products and services shall be
                competetive on an international level.
            </p>
        </div>
    </div>
</div>

<style>
    .grid {
        display: grid;
        grid-template-columns: 1fr 1fr 1fr;
        gap: 25px;
    }

    hr {
        margin-top: 50px;
        margin-bottom: 50px;
    }

    @media screen and (max-width: 900px) {
        .grid {
            grid-template-columns: 1fr;
        }
        .container {
            padding-bottom: 100px !important;
        }
    }

    .container {
        padding-top: 100px;
        padding-bottom: 300px;
    }
</style>
